// extracted by mini-css-extract-plugin
export default {"dateAdapter":"DatePicker_dateAdapter__sPKQL"};